import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useSaved } from "../context/SavedContext";
import "./Header.css";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/search", label: "Recherche" },
  { to: "/saved", label: "Favoris" },
  { to: "/purpose", label: "À propos" },
];

function navClass({ isActive }) {
  return isActive ? "pa-nav__link is-active" : "pa-nav__link";
}

function Header() {
  const { saved } = useSaved();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const savedCount = Object.keys(saved).length;

  // Close the mobile panel on navigation and on Escape.
  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [open]);

  return (
    <header className="pa-nav">
      <div className="container pa-nav__bar">
        <NavLink to="/" className="pa-brand">
          <span className="pa-brand__a">Paris</span>
          <span className="pa-brand__b">Agenda</span>
        </NavLink>

        <nav className="pa-nav__links" aria-label="Navigation principale">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} className={navClass}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <NavLink to="/saved" className="pa-nav__saved">
          <i className="bi bi-bookmark" aria-hidden="true"></i>
          {savedCount > 0 ? (
            <>
              {savedCount} favori{savedCount > 1 ? "s" : ""}
            </>
          ) : (
            "Favoris"
          )}
        </NavLink>

        <button
          type="button"
          className="pa-nav__toggle"
          aria-expanded={open}
          aria-controls="pa-nav-panel"
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "bi bi-x-lg" : "bi bi-list"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <nav
          id="pa-nav-panel"
          className="pa-nav__panel"
          aria-label="Navigation principale"
        >
          <div className="container">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={navClass}
              >
                {l.label}
                {l.to === "/saved" && savedCount > 0 && (
                  <span className="pa-nav__badge">{savedCount}</span>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}

export default Header;
